import React from 'react'
import {
  BookingCalendarSteps,
  timeFormatLabels,
} from 'common/components/entities/Calendar/constants'
import { useActions } from 'common/hooks/useActions'
import { changeBookingCalendarStepType } from 'client/actions/actionsManagement'
import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import useManagement, {
  selectors as managementSelectors,
} from 'client/hooks/useManagement'
import Input from '../../components/Input/Input'
import { useUpdateProp } from '../../hooks/useUpdateProps'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'

interface BookingPaidCalendarStepsSwitcherProps {
  entity: BookingPaidCalendarInterface
}

export const BookingPaidCalendarStepsSwitcher = ({
  entity,
}: BookingPaidCalendarStepsSwitcherProps) => {
  const updateProp = useUpdateProp(entity)

  const stepType = useManagement(managementSelectors.getBookingCalendarStepType)
  const changeStep = useActions(changeBookingCalendarStepType)
  const isCalendarStep = stepType === BookingCalendarSteps.CalendarStep
  const isFormStep = stepType === BookingCalendarSteps.FormStep

  return (
    <React.Fragment>
      <Switcher
        btnList={[
          {
            value: BookingCalendarSteps.CalendarStep,
            content: 'entity_settings.booking_calendar.switch_calendar_step',
          },
          {
            value: BookingCalendarSteps.FormStep,
            content: 'entity_settings.booking_calendar.switch_form_step',
          },
        ]}
        value={stepType}
        update={changeStep}
      />
      {isCalendarStep && (
        <React.Fragment>
          <Input
            value={entity.calendarStepHeadline}
            update={updateProp('calendarStepHeadline')}
            label="entity_settings.booking_calendar.headline"
          />
          <Input
            value={entity.calendarStepSubHeadline}
            update={updateProp('calendarStepSubHeadline')}
            label="entity_settings.booking_calendar.sub_headline"
          />
          <Input
            value={entity.nextStepButtonText}
            update={updateProp('nextStepButtonText')}
            label="entity_settings.booking_calendar.next_step_button_text"
          />
        </React.Fragment>
      )}
      {isFormStep && (
        <React.Fragment>
          <Input
            value={entity.formStepHeadline}
            update={updateProp('formStepHeadline')}
            label="entity_settings.booking_calendar.headline"
          />
          <Input
            value={entity.formStepSubHeadline}
            update={updateProp('formStepSubHeadline')}
            label="entity_settings.booking_calendar.sub_headline"
          />
          <Input
            value={entity.formButtonText}
            update={updateProp('formButtonText')}
            label="entity_settings.booking_calendar.formButtonText"
          />
        </React.Fragment>
      )}
      <Select
        labelText="entity_settings.booking_calendar.time_format.label"
        value={entity.timeFormat}
        update={updateProp('timeFormat')}
        choiceList={timeFormatLabels}
      />
    </React.Fragment>
  )
}
